import { Autocomplete, Chip, TextField } from '@mui/material'
import { MultiAutoCompleteProps } from './MultiAutoComplete.types'

export const MultiAutoComplete = ({
  title,
  subTitle,
  options = [],
  value,
  onChange,
}: MultiAutoCompleteProps) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="font-title">{title}</div>
      <div className="-mt-1 text-xs text-gray-light">{subTitle}</div>

      <Autocomplete
        multiple
        options={options}
        filterSelectedOptions
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={value}
        onChange={(_, newValue) => {
          onChange(newValue)
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              {...getTagProps({ index })}
              label={
                option.name ??
                options.find((op) => op.id === option.id)?.name ??
                ''
              }
              onDelete={() => onChange(value.filter((v) => v.id !== option.id))}
              key={option.id}
              variant="outlined"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            sx={{
              '& .MuiOutlinedInput-root': {
                padding: '8px',
                border: '1px solid #E2E3E6',
                minHeight: '32px',
                borderRadius: '8px',
                '&:hover': {
                  border: '1px solid #292929',
                },
                '& input:focus': {
                  boxShadow: 'none',
                },
              },
              '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            }}
            {...params}
          />
        )}
      />
    </div>
  )
}
